import FaqLayout from "@/components/feature/FaqLayout";

export default function CancelSubscriptionPage() {
  return (
    <FaqLayout
      breadcrumb="/ Subscription Management"
      title="Cancelling my"
      accent="subscription"
    >
      <div className="space-y-6 text-[#1A1C1E]">
        <h2 className="text-2xl font-bold text-[#1A1C1E]">How to Cancel Your Subscription</h2>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          You can cancel your subscription at any time through your account dashboard. Once cancelled, you will retain access to all features until the end of your current billing period.
        </p>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Step-by-Step Cancellation</h3>
        <ol className="list-decimal list-inside space-y-3 text-[15px] leading-relaxed text-[#4B5563]">
          <li>Log into your Trevionix account and navigate to <strong>Account Settings</strong>.</li>
          <li>Select <strong>Subscription & Billing</strong> from the left-hand menu.</li>
          <li>Click the <strong>Cancel Subscription</strong> button at the bottom of the page.</li>
          <li>Follow the on-screen prompts to confirm your cancellation.</li>
          <li>You will receive a confirmation email once the cancellation is processed.</li>
        </ol>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">What Happens After Cancellation?</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          Your subscription remains active until the end of the current billing cycle. After that date, your account will be downgraded to the free plan and you will lose access to premium features. No further charges will be applied to your payment method.
        </p>

        <h3 className="text-lg font-semibold text-[#1A1C1E] mt-8">Refund Policy</h3>
        <p className="text-[15px] leading-relaxed text-[#4B5563]">
          We do not offer prorated refunds for partial billing periods. If you believe you are entitled to a refund due to exceptional circumstances, please contact our support team within 14 days of your cancellation.
        </p>

        <div className="bg-[#F7F5F2] rounded-xl p-6 mt-8">
          <p className="text-sm font-semibold text-[#1A1C1E] mb-2">Need immediate assistance?</p>
          <p className="text-sm text-[#6C7278]">
            If you are experiencing issues with cancellation or have questions about your billing, our support team is available Monday through Friday, 9:00 AM – 6:00 PM GMT.
          </p>
        </div>
      </div>
    </FaqLayout>
  );
}